import router from './router';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken, getPlateForm, hasPermission } from '@/utils/auth';
import getPageTitle from '@/utils/get-page-title';
import Store from '@/store/index.js';
import { MessageBox } from 'element-ui';
NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = ['/login', '/bpmn']; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  const hasNewVersion = sessionStorage.getItem('hasNewVersion') === 'true';
  if (hasNewVersion) {
    sessionStorage.removeItem('hasNewVersion');
    MessageBox.alert('检测到新版本，点击确定更新', '版本更新', {
      confirmButtonText: '确定',
      showClose: false,
      closeOnClickModal: false,
      closeOnPressEscape: false
    })
      .then(() => {
        window.location.reload();
      })
      .catch(() => next());
    return;
  }
  // start progress bar
  NProgress.start();
  to.meta.previousRoute = from;
  // set page title
  document.title = getPageTitle(to.meta.title);

  // determine whether the user has logged in
  const hasToken = getToken();

  if (
    to.path === '/big/resourceManage/resourceManageList' &&
    (import.meta.env.VITE_ENV.includes('test') ||
      import.meta.env.VITE_ENV.includes('pre') ||
      import.meta.env.VITE_ENV.includes('master') ||
      import.meta.env.VITE_ENV.includes('allist'))
  ) {
    next({ path: '/401' });
    NProgress.done();
  }

  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' });
      NProgress.done(); // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else {
      const plateForm = getPlateForm();
      if (to.meta && to.meta.roles) {
        // 界面设置了权限
        if (
          hasPermission(plateForm, to.meta.roles) &&
          (!to?.meta?.menuId ||
            Store?.state?.app?.permissionCodes?.includes(to.meta.menuId))
        ) {
          // 有权限
          next();
        } else {
          // 没有权限
          next({ path: '/401' });
        }
      } else {
        // 界面没有设置权限，可以直接进入
        next();
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly

      next();
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
